import { Avatar, Box, IconButton, Stack } from "@mui/material";
import { IconDots } from "@tabler/icons-react";
import Input from "../../../../components/ui/Input";
import Text from "../../../../components/ui/Text";

export const Team = ({ name, players, setTeamName, handlePlayerMenuOpen }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Input
        label="Team name"
        value={name}
        onChange={(e) => setTeamName(e.target.value)}
        placeholder={`Team name`}
        sx={{ mb: 3 }}
      />

      <Box sx={{ backgroundColor: "#F5F5F5", borderRadius: 2, p: 2, mt: 2 }}>
        <Stack spacing={2}>
          {players.map((player) => (
            <Box
              key={player.player_id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                bgcolor: "white",
                p: 2,
                borderRadius: 1,
              }}
            >
              <Avatar
                src={player.profile_image_url}
                sx={{ width: 40, height: 40, fontSize: "16px" }}
              >
                {player.first_name?.[0]?.toUpperCase()}
                {player.last_name?.[0]?.toUpperCase()}
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Text
                  variant="paragraph"
                  sx={{ fontSize: "16px", fontWeight: 500 }}
                >
                  {player.first_name} {player.last_name}
                </Text>
              </Box>

              {players.length > 1 && (
                <IconButton
                  size="small"
                  onClick={(event) => {
                    handlePlayerMenuOpen(event, player);
                  }}
                  sx={{
                    color: "#A1A1A1",
                    "&:hover": {
                      backgroundColor: "#F5F5F5",
                    },
                  }}
                >
                  <IconDots size={16} />
                </IconButton>
              )}
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};
